import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { userService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import { Redirect, Route } from 'react-router-dom';


export class UserRegistration extends Component {
    displayName = UserRegistration.name

    constructor(props) {
        super(props);
        this.state = {
            user: {
                firstName: '',
                lastName: '',
                phoneNumber: '',
                emailAddress: '',
                username: '',
                password: '',
                iAgree: false,
                captcha: false,
                redirectToLogin: false
            },
            errors: {},
            message: "",
            submitted: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleRegistration = this.handleRegistration.bind(this);
        this.handlecheckChange = this.handlecheckChange.bind(this);  
        this.handleCaptcha = this.handleCaptcha.bind(this);
        
    }

    validateForm() {

        let fields = this.state.user;
        let errors = {};
        let formIsValid = true;

        if (!fields["firstName"]) {
            formIsValid = false;
            errors["firstName"] = "Please enter your first name.";
        }
        else if (typeof fields["firstName"] !== "undefined") {
            if (!fields["firstName"].match(/^[a-zA-Z ]*$/)) {
                formIsValid = false;
                errors["firstName"] = "Please enter alphabet characters only.";
            }
        }


        if (!fields["lastName"]) {
            formIsValid = false;
            errors["lastName"] = "Please enter your last name.";
        }
        else if (typeof fields["lastName"] !== "undefined") {
            if (!fields["lastName"].match(/^[a-zA-Z ]*$/)) {
                formIsValid = false;
                errors["lastName"] = "Please enter alphabet characters only.";
            }
        }

        if (!fields["emailAddress"]) {
            formIsValid = false;
            errors["emailAddress"] = "Please enter your email-ID.";
        }

        else if (typeof fields["emailAddress"] !== "undefined") {
            //regular expression for email validation
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(fields["emailAddress"])) {
                formIsValid = false;
                errors["emailAddress"] = "Please enter valid email-ID.";
            }
        }

        //if (!fields["phoneNumber"]) {
        //    formIsValid = false;
        //    errors["phoneNumber"] = "*Please enter your mobile no.";
        //}

        //if (typeof fields["phoneNumber"] !== "undefined") {
        //    if (!fields["phoneNumber"].match(/^[- +()]*[0-9][- +()0-9]*$/)) {
        //        formIsValid = false;
        //        errors["phoneNumber"] = "*Please enter valid mobile no.";
        //    }
        //}

        //if (!fields["username"]) {
        //    formIsValid = false;
        //    errors["username"] = "Please enter your user name.";
        //}
        //else if (typeof fields["username"] !== "undefined") {
        //    if (!fields["username"].match(/^[a-zA-Z0-9]*$/)) {
        //        formIsValid = false;
        //        errors["username"] = "*Please enter alphabet characters and numbers only.";
        //    }
        //}

        if (!fields["password"]) {
            formIsValid = false;
            errors["password"] = "Please enter your password.";
        }

        else if (typeof fields["password"] !== "undefined") {
            if (!fields["password"].match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()+-]).*$/)) {
                formIsValid = false;
                errors["password"] = "Password must be 8 characters long and contain one capital letter, one small letter, one number and one special character (!@#$%^&*-=_+).";
            }
        }

        this.setState({
            errors: errors
        });
        return formIsValid;

    }

    handleRegistration(evt) {
        let fields = this.state.user;

        if (!fields["captcha"]) {
            alert("Please solve the captcha");
            return false;
        }
        if (!fields["iAgree"]) {
            alert("Please click on consent checkbox to register.");            
            return false;
        }
        

        if (this.validateForm()) {

            var regParameter = {
                FirstName: this.state.user.firstName, LastName: this.state.user.lastName, Email: this.state.user.emailAddress, Password: this.state.user.password, Username: this.state.user.emailAddress
            }
            var self = this;
            userService.registerUser(regParameter)
                .then(function (data) {
                    self.setState({ message: data });
                    alert(data);
                    if (data == "User registered successfully") {
                        self.setState({ redirectToLogin: true });
                    }
                    if (data != "") {
                        self.setState({
                            user: {
                                username: '',
                                emailAddress: '',
                                password: '',
                                firstName: '',
                                lastName: '',
                                iAgree: false,
                                captcha: false
                            }
                        });
                    }
                });

        }

    }

    handleChange(event) {
        const { name, value } = event.target;
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    }

    handleCaptcha(evt) {
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                captcha: evt.target.checked
            }
        });
    }

    handlecheckChange(evt) {
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                iAgree: evt.target.checked
            }
        });
    }

    render() {

        if (this.state.redirectToLogin) {

            return <Redirect to={"/Login"} />
        }
        const meta = {
            title: "Kluwer Law Online - User registration",
            canonical: window.location.href,
        }
        const { user, submitted } = this.state;
        return (
            <DocumentMeta {...meta}>
                <div className="col-12 klo-shopshopping-cart">
                    <div className="row">
                        <div className="col-lg-12 colPadding margintop">
                            <div id="yourDetails" className="mt-3" >
                                <div className="col-sm-12 row">
                                    <div className="col">
                                        <div className="row">
                                            <form style={{ width: '55%' }}>
                                                <p className="franziskafont" style={{ fontSize: '17px' }}>User Registration</p>
                                                <div className="form-row mt-3">
                                                    <div className="col">
                                                        <label for="firstName">First name</label>
                                                        <input type="text" className="form-control form-control-sm rounded-0" name="firstName" id="firstName" value={user.firstName} onChange={this.handleChange} placeholder="First name" />
                                                        <div className="errorMsg">{this.state.errors.firstName}</div>
                                                    </div>
                                                    <div className="col">
                                                        <label for="lastName">Last name</label>
                                                        <input type="text" className="form-control form-control-sm rounded-0" id="lastName" name="lastName" value={user.lastName} onChange={this.handleChange} placeholder="Last name" />
                                                        <div className="errorMsg">{this.state.errors.lastName}</div>
                                                    </div>
                                                </div>
                                                <div className="form-group mt-3 col-8 col-sm-12 px-0">
                                                    <label for="emailAddress">Email address</label>
                                                    <input type="email" className="form-control form-control-sm rounded-0" placeholder="Email" id="emailAddress" name="emailAddress" value={user.emailAddress} onChange={this.handleChange} />
                                                    <div className="errorMsg">{this.state.errors.emailAddress}</div>
                                                </div>

                                                <div className="form-group mt-3 col-6 px-0">
                                                    <label for="password">Password</label>
                                                    <input type="password" className="form-control form-control-sm rounded-0" placeholder="Password" id="password" name="password" value={user.password} onChange={this.handleChange} />
                                                    <div className="errorMsg">{this.state.errors.password}</div>
                                                </div>

                                                <div style={{ display: 'none' }} className="form-group mt-3 col-6 px-0">
                                                    <label for="phoneNumber">Phone Number</label>
                                                    <input type="text" className="form-control form-control-sm rounded-0" id="phoneNumber" placeholder="Phone Number" name="phoneNumber" value={user.phoneNumber} onChange={this.handleChange} />
                                                    <div className="errorMsg">{this.state.errors.phoneNumber}</div>
                                                </div>

                                                <div className="square">
                                                    <input type="checkbox" id="GDPR" checked={this.state.user.iAgree} onChange={this.handlecheckChange}/>
                                                    <label for="GDPR"></label>
                                                    <span className="Searchlabel">I consent to the collection of my personal information by Kluwer Law International to create an account and store my contact information.  For more information about our privacy policy, <a className="LinkClass" target="_blank" href="http://www.kluwerlaw.com/gdpr/">click here</a>.</span>
                                                </div>
                                                <br></br>

                                              
                                                    <div class="rc-anchor rc-anchor-normal rc-anchor-light">
                                                        <div class="rc-anchor-content">
                                                            <div class="rc-inline-block">
                                                                <div class="rc-anchor-center-container">
                                                                    <div class="rc-anchor-center-item rc-anchor-checkbox-holder">
                                                                        <span class="recaptcha-checkbox goog-inline-block recaptcha-checkbox-unchecked rc-anchor-checkbox recaptcha-checkbox-clearOutline" role="checkbox" aria-checked="false" id="recaptcha-anchor" tabindex="0" dir="ltr" aria-labelledby="recaptcha-anchor-label">
                                                                            <div className="square" style={{ width: '35px', paddingLeft: '1%' }}>
                                                                            <input type="checkbox" id="captcha" checked={this.state.user.captcha} onChange={this.handleCaptcha} />
                                                                                <label for="captcha"></label>
                                                                            </div>
                                                                            <div class="recaptcha-checkbox-spinner" role="presentation"></div>
                                                                            <div class="recaptcha-checkbox-spinnerAnimation" role="presentation"></div>

                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="rc-inline-block">
                                                                <div class="rc-anchor-center-container"><label class="rc-anchor-center-item rc-anchor-checkbox-label" id="recaptcha-anchor-label">I'm not a robot</label></div>
                                                            </div>
                                                        </div>
                                                        <div class="rc-anchor-normal-footer">
                                                            <div class="rc-anchor-logo-portrait" role="presentation">
                                                                <div class="rc-anchor-logo-img rc-anchor-logo-img-portrait"></div>
                                                                <div class="rc-anchor-logo-text">reCAPTCHA</div>
                                                            </div>
                                                            <div class="rc-anchor-pt"><a href="https://www.google.com/intl/en/policies/privacy/" target="_blank">Privacy</a> - <a href="https://www.google.com/intl/en/policies/terms/" target="_blank">Terms</a></div>
                                                        </div>
                                                    </div>
                                                <br></br>

                                            </form>
                                        </div>
                                        <div className="row">
                                            <button type="button" className="btn next rounded-0" onClick={this.handleRegistration} >Create account</button>
                                        </div>
                                    </div>

                                    <div className="col-0 border-right"> </div>

                                </div>
                                <div className="col-lg-12 row mb-5 mt-3 ">

                                    <div className="col colPadding">
                                        <img src="//klitag.scholarlyiq.com/siqpagetag.gif?js=0" height="1" width="1" border="0" hspace="0" vspace="0" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/UserRegistration.jsx